module.exports = __webpack_public_path__ + "static/media/episode1art.8412f6bc.jpg";